import React, { useState } from "react";
import { Box } from "@mui/material";
import ByzMuiDataGrid from "src/components/core-components/mui/data-grid";
import { useDocumentsColumns, initialDocumentsData } from "./data";
import { useTranslate } from "src/locales";
import {

} from "@mui/x-data-grid-premium";
import ByzMuiSnackBar from "src/components/core-components/mui/ByzMuiSnackBar";
import ByzDataGridToolbar from "src/components/core-components/mui/data-grid/toolbar";
//MUZUN;454081;07042025


const DocumentsPanel: React.FC = () => {
  const { t } = useTranslate();
  const columns = useDocumentsColumns();
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage] = useState("");
  const [alertSeverity] = useState<"error" | "success">(
    "success"
  );
  return (
    <>
      <Box sx={{ padding: "20px", width: "100%", maxHeight: "90vh", overflow: "auto" }}>
        <ByzMuiDataGrid
          customToolbar={ByzDataGridToolbar}
          columns={columns}
          pageSize={10}
          rows={initialDocumentsData}
        />
      </Box>
      <ByzMuiSnackBar
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
        title={
          alertSeverity === "success"
            ? t("operation-successful")
            : t("error")
        }
        message={alertMessage}
        type={alertSeverity}
      />
    </>
  );
};

export default DocumentsPanel;
